import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "player" }
const _hoisted_2 = { class: "player-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "player-left-modal" }, null, -1)
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "player-right" }
const _hoisted_6 = { class: "title" }
const _hoisted_7 = {
  key: 1,
  style: {"font-size":"12px","color":"#666","line-height":"16px"}
}
const _hoisted_8 = { class: "controller" }
const _hoisted_9 = { class: "time" }
const _hoisted_10 = { class: "volume" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-zhongzhi2" }, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-gedan" }, null, -1)
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("i", { class: "iconfont icon-yinlegedanyinfu" }, null, -1)
const _hoisted_16 = [
  _hoisted_15
]
const _hoisted_17 = ["onClick"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("span", { class: "list-cur" }, null, -1)
const _hoisted_19 = { class: "list-index" }
const _hoisted_20 = { class: "list-title" }
const _hoisted_21 = { class: "list-author" }


const __default__ = { name: '' };

import '@/assets/svg/home-svg/fonticon/iconfont.css';
import { reactive, ref, onMounted, onUnmounted, computed, onUpdated, watch, PropType } from 'vue';
import { storage } from '@/helpers/storage';
import { useRoute } from 'vue-router';
// 普通方式定义
// const props = defineProps({
//   audioList: {
//     type: Array as PropType<any[]>,
//   }
// })

// ts独有方式定义（含默认值）
interface lrcType {
  time: string,
  text: string,
}
interface AudioType {
  audioSrc: any;
  title: string;
  author: string;
  imgSrc: any;
  lrc: lrcType[];
}
// 上面的方式定义规则性强； 下面的定义方式规则性弱，类型是any。
// type AudioType = Record<string, any>
interface Props {
  audioList: AudioType[],
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    audioList: { default: () => { return [] as AudioType[] } }
  },
  setup(__props: any, { expose }) {

const props = __props as { audioList: AudioType[] }



// ts独有方式定义（不含默认值）
// const props = defineProps<{
//   audioList: any[]
// }>()

// 格式化歌曲时长
const formatMusicTime = (val: number) => {
  if (Math.floor(val % 60).toString().length === 1) {
    return `0${Math.floor(val / 60)}:0${Math.floor(val % 60)}`
  } else if (Math.floor(val / 60).toString().length === 1) {
    return `0${Math.floor(val / 60)}:${Math.floor(val % 60)}`
  } else {
    return `${Math.floor(val / 60)}:${Math.floor(val % 60)}`
  }
}

// 拿到audio标签（歌曲）
// const audio = ref<HTMLAudioElement>()
const audio = ref<HTMLAudioElement>(new Audio())

// 定义歌曲的时长
const audioDuration = ref()

// 播放歌曲fn()
const play = () => {
  // 当进度条被拉至最末尾时执行
  if (audioCurrentTime.value === audioDuration.value) {
    endedFn()
  } else {
    // 正常情况下执行
    audio.value?.play()
  }
}

// 暂停歌曲fn()
const stop = () => {
  audio.value?.pause()
}

// 重置歌曲fn()
const load = () => {
  audio.value?.load()
}

// 定义记录当前歌曲是否播放，控制icon的切换
const isPlay = ref(false)

// 组件左边模块的点击事件fn()
const playerLeftClick = () => {
  isPlay.value = !isPlay.value
  if (isPlay.value) {
    play();
  } else {
    stop();
  }
}

// 注册dom上的lrc
const lrc = ref<HTMLDivElement>()
// 定义lrcPosition作为lrc-contents的位移距离
const lrcPosition = ref(0)
// 记录当前歌词的p标签
const pIndex = ref(0)


// 获取progress的dom
const progress = ref<HTMLDivElement>()
// 获取progress的宽度
const progressWidth = ref()
// 当前彩色进度条的length
const progressBuffered = ref(0)
// 定义是否开启动画，在滑动时关闭，在点击结束时开启
const isProgressItemTransition = ref(true)
// 记录progress最左侧距离浏览器窗口左边的位置
const progressLeft = ref()

// 已播放时长
const audioCurrentTime = ref('00:00')
// 根据播放了的时间与总时长，获取彩色进度条的length
const timeupdateFn = () => {
  // 获取当前播放时间
  audioCurrentTime.value = formatMusicTime(audio.value?.currentTime!)
  // 获取歌词所有的p标签
  const lrcPAll = lrc.value?.querySelectorAll('p')
  // 获取当前p标签的下标
  pIndex.value = props.audioList[focusIndex2].lrc.filter((item) => item.time <= audioCurrentTime.value).length - 1
  // 根据p标签的下标获取该p标签距离父级顶部的距离，这段距离就是要位移的距离
  lrcPosition.value = lrcPAll![pIndex.value]?.offsetTop
  
  // 当在列表中切换歌曲时，切换的瞬间拿不到歌曲的时长，会变成NaN，当拿不到时给0（避免计算出的值为NaN）
  if (audio.value?.duration) {
    progressBuffered.value = audio.value?.currentTime! / audio.value?.duration * 100
  } else {
    progressBuffered.value = 0
  }
}

// 定义当音乐结束时触发的事件
const endedFn = () => {
  // 顺序播放
  if (playType.value === 0) {
    if (focusIndex2 === props.audioList.length - 1) {
      focusIndex2 = -1
    }
    // 重置audio的src
    audio.value!.src = props.audioList[++focusIndex2]?.audioSrc
    // 重置音乐播放器歌曲信息
    focusIndex.value = focusIndex2
  // 随机播放
  } else if (playType.value === 1) {
    const max = props.audioList.length - 1
    const index = Math.floor(Math.random() * (max - 0 + 1)) + 0;
    // 重置audio的src
    audio.value!.src = props.audioList[index]?.audioSrc
    // 重置音乐播放器歌曲信息
    focusIndex2 = index
    focusIndex.value = index
  // 单曲循环
  } else {
    load()
  }
  audio.value?.play()
  isPlay.value = true
}

// 鼠标点击后滑动触发的事件
const mousemoveFn = (e: MouseEvent) => {
  // 在滑动过程中取消这个事件，避免当当前音乐在播放，而拖到最末尾时立即播放下一首歌
  audio.value?.removeEventListener('ended', endedFn)
  // 在滑动过程中暂停歌曲
  stop()
  // 关闭进度条的动画效果
  isProgressItemTransition.value = false;
  // 点击的位置与总长度的百分比
  let percent = (e.clientX - progressLeft.value) / progressWidth.value
  if (percent < 0) {
    percent = 0
  } else if (percent > 1) {
    percent = 1
  }
  // 重置当前彩色进度条的length 和 播放位置
  // progressBuffered.value = percent * 100
  audio.value!.currentTime = percent * audio.value?.duration!
  timeupdateFn()
  // audioCurrentTime.value = formatMusicTime(audio.value?.currentTime!)
}

// 记录点击未弹起时的位置
let getIntoPosition: number;
// 鼠标在progress点击时触发事件
const progressMousedown = (e: MouseEvent) => {
  // 此时移除 audio 上的 timeupdate 事件监听
  audio.value?.removeEventListener('timeupdate', timeupdateFn)
  // 获取progress的总长度（在这里获取可保证获取到正确的长度）
  progressWidth.value = progress.value?.getBoundingClientRect().width
  // 获取progress最左侧距离浏览器窗口左边的位置
  progressLeft.value = progress.value?.getBoundingClientRect().left
  // 获取点击未弹起时的位置
  getIntoPosition = e.offsetX
  window.addEventListener('mousemove', mousemoveFn)
  window.addEventListener('mouseup', mouseUpFn);
}

// 窗口的mouseup事件
const mouseUpFn = (e: MouseEvent) => {
  // 在鼠标弹起后继续监听该事件
  audio.value?.addEventListener('ended', endedFn)
  // 开启进度条的动画效果
  isProgressItemTransition.value = true;
  // 移除鼠标滑动时的事件监听
  window.removeEventListener('mousemove', mousemoveFn)
  // 根据点击未弹起时的位置和放开时的位置作比较，判断是否有触发move，如果没有移动则是点击事件
  // 在此重置当前歌曲的播放位置(这里e.offsetX是弹起时的位置)
  if (getIntoPosition === e.offsetX) {
    audio.value!.currentTime = e.offsetX / progressWidth.value * audio.value?.duration!
  }
  // 重新开启 audio 上的 timeupdate 事件监听
  audio.value?.addEventListener('timeupdate', timeupdateFn)
  // 在滑动结束时判断是否开启歌曲
   if (isPlay.value) {
    play()
  }
  // 移除鼠标弹起时的事件监听
  window.removeEventListener('mouseup', mouseUpFn);
};


// 定义记录当前的喇叭icon状态
const isVolume = ref(false)
// 定义并获取volume dom
const volume = ref<HTMLDivElement>()
// 定义volume与窗口顶部的距离
const volumeTop = ref()
// 定义volume的自身高度
const volumeHeight = ref()
// 定义volume-bar(颜色柱子)的高度
const volumeBarHeight = ref()
// 定义audio的volume
// const audioVolume = ref()
// 定义布尔值决定音量柱子是否隐藏
const isVolumeWrapHeightClass = ref(false)
// 记录点击未弹起时的位置
let getIntoPositionVolume: number;

// 点击volume未弹起位移时触发该事件
const volumeMousemove = (e: MouseEvent) => {
  // 彩色柱子高度百分比：1 - （鼠标距离 - dom到浏览器窗口顶部距离）/ 柱子总长
  let percent = 1 - (e.clientY - volumeTop.value) / volumeHeight.value
  if (percent < 0) {
    percent = 0
  } else if (percent > 1) {
    percent = 1
  }
  // 重置彩色柱子高度
  volumeBarHeight.value = percent * 100
  // 重置音量
  // audio.value!.volume = +percent.toFixed(2)
  if (audio.value) {
    audio.value.volume = +percent.toFixed(2)
  }
}
// 在点击volume后弹起时触发该事件
const volumeMouseup = (e: MouseEvent) => {
  // 弹起时立即移除move事件
  window.removeEventListener('mousemove', volumeMousemove)
  // 当鼠标不在dom上时，隐藏这个类，柱子隐藏
  isVolumeWrapHeightClass.value = false
  // 根据记录点击未弹起时的位置判断是否触发move事件，如果没有触发，说明是点击事件，在这里重置柱子高度和音量大小
  if (getIntoPositionVolume === e.offsetY) {
    // 根据鼠标在dom的位置 / 总长度来得到百分比
    let percent = 1 - (e.offsetY / volumeHeight.value)
    volumeBarHeight.value = percent * 100
    // audio.value!.volume = +percent.toFixed(2)
    if (audio.value) {
      audio.value.volume = +percent.toFixed(2)
    }
  }
  // 移除自身的这个mouseup事件
  window.removeEventListener('mouseup', volumeMouseup)
}
// 点击volume未弹起时触发事件
const volumeMousedown = (e: MouseEvent) => {
  // 一旦点击dom则开启这个类，当鼠标移出dom后，dom依然不会隐藏
  isVolumeWrapHeightClass.value = true
  // dom的高度
  volumeHeight.value = volume.value?.getBoundingClientRect().height
  // dom的上边框距离浏览器窗口的顶部距离
  volumeTop.value = volume.value?.getBoundingClientRect().top
  // 拿到点击时的位置
  getIntoPositionVolume = e.offsetY
  // 注册事件监听器
  window.addEventListener('mousemove', volumeMousemove)
  window.addEventListener('mouseup', volumeMouseup)
}
// volumeIcon的点击事件
const volumeIconClick = () => {
  // 点击切换icon
  isVolume.value = !isVolume.value
  // true是关闭音量
  if (isVolume.value) {
    // 在关闭音量前让 oldVoiceVolume 保留原有音量
    storage.value.oldVoiceVolume = storage.value.voiceVolume
    volumeBarHeight.value = 0
    audio.value!.volume = 0
  } else {
    // false是开启音量
    // 开启音量时让当前音量去拿关闭前保留的音量 oldVoiceVolume
    storage.value.voiceVolume = storage.value.oldVoiceVolume
    volumeBarHeight.value = storage.value.voiceVolume * 100
    audio.value!.volume = storage.value.voiceVolume
  }
}
// 根据音量颜色条来判断使用哪个icon
watch(volumeBarHeight, (newVal, oldVal) => {
  if (newVal === 0) {
    isVolume.value = true
  } else {
    isVolume.value = false
  }
})


// 定义播放模式的icon类名
const playTypeIcon = ['icon-hanhan-01-01', 'icon-24gl-shuffle', 'icon-24gl-repeat2']
// 定义播放模式的icon类名下标
const playType = ref(0)
// 播放模式的点击事件，修改icon类名下标
const playTypeClick = () => {
  playType.value++;
  if(playType.value > playTypeIcon.length - 1) {
    playType.value = 0
  }
}

// 重置当前歌曲
const resetClick = () => {
  load();
  if (isPlay.value) {
    play();
  }
}

// 定义是否显示歌曲列表
const isShowPlayerList = ref(false);
// 保留下当前点击的li标签的下标
const focusIndex = ref(0)
let focusIndex2:number = 0;
// li标签点击事件
const liClick = (index: number) => {
  // 重置audio的src
  audio.value!.src = props.audioList[index].audioSrc
  // 重置focusIndex
  focusIndex.value = index
  focusIndex2 = index
  play()
  if (isPlay.value === false) {
    isPlay.value = true
  }
}
// 拿到route
const route = useRoute()
// 当页面跳转停止播放歌曲
watch(route, () => {
  stop()
})

// audio.value?.buffered // 返回已缓冲的length
// audio.value?.currentTime //属性会以秒为单位返回当前媒体元素的播放时间。设置这个属性会改变媒体元素当前播放位置。
// audio.value?.loop // 属性是 HTML 标签 loop 属性的映射，它决定了媒体元素播放结束时是否重新开始。
// 属性(只读).paused 告诉视频是否正在暂停
// .volume 属性可设置媒体播放时的音量。
// load() 方法重置媒体成初始化状态，选择一个播放源， 为载入媒体重新播放做准备。

onMounted(() => {
  // 初始化音乐链接
  audio.value!.src = props.audioList[0].audioSrc
  // 当音乐播放时，每隔250ms回调一次该事件
  audio.value?.addEventListener('timeupdate', timeupdateFn)
  // 当音乐准备好可以播放时触发该事件
  audio.value?.addEventListener('canplay', () => {
    // 音乐总时长
    audioDuration.value = formatMusicTime(audio.value?.duration!)
    // 音乐音量初始化
    // audio.value!.volume = storage.value.voiceVolume
    if (audio.value) {
      audio.value.volume = storage.value.voiceVolume
    }
    // audioVolume.value = audio.value?.volume
    // 音量柱子初始化
    volumeBarHeight.value = audio.value!.volume * 100
  })
  // 当改变音量大小时触发
  audio.value?.addEventListener('volumechange', (e: Event) => {
    const audio = e.target as HTMLAudioElement;
    storage.value.voiceVolume = audio.volume;
  })

  // 当音乐播放结束时触发
  audio.value?.addEventListener('ended', endedFn)
  // 当音乐播放结束时触发（该函数已提到上面的endedFn中）
  // audio.value?.addEventListener('ended', () => {
  //   // 顺序播放
  //   if (playType.value === 0) {
  //     if (focusIndex2 === props.audioList.length - 1) {
  //       focusIndex2 = -1
  //     }
  //     // 重置audio的src
  //     audio.value!.src = props.audioList[++focusIndex2]?.audioSrc
  //     // 重置音乐播放器歌曲信息
  //     focusIndex.value = focusIndex2
  //   // 随机播放
  //   } else if (playType.value === 1) {
  //     const max = props.audioList.length - 1
  //     const index = Math.floor(Math.random() * (max - 0 + 1)) + 0;
  //     // 重置audio的src
  //     audio.value!.src = props.audioList[index]?.audioSrc
  //     // 重置音乐播放器歌曲信息
  //     focusIndex.value = index
  //   // 单曲循环
  //   } else {
  //     resetClick()
  //   }
  //   play()
  //   isPlay.value = true
  // })

  // 此位置拿不到正确的progressWidth值（暂不知为什么）
  // progressWidth.value = progress.value?.getBoundingClientRect().width
  // console.log(progressWidth.value);

  // window.addEventListener('resize', () => {
    // progressWidth.value = progress.value?.offsetWidth
    // console.log(progress.value?.offsetWidth);
  // })
});

expose({
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "player-left",
        onClick: playerLeftClick
      }, [
        _hoisted_3,
        _createElementVNode("img", {
          src: __props.audioList[focusIndex.value].imgSrc,
          alt: ""
        }, null, 8, _hoisted_4),
        _createElementVNode("div", {
          class: _normalizeClass(["player-left-icon", {'player-left-icon-is_play':isPlay.value}])
        }, [
          _createElementVNode("i", {
            class: _normalizeClass(["iconfont", isPlay.value ? 'icon-zanting2':'icon-bofang'])
          }, null, 2)
        ], 2)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          _createTextVNode(_toDisplayString(__props.audioList[focusIndex.value].title), 1),
          _createElementVNode("span", null, " - " + _toDisplayString(__props.audioList[focusIndex.value].author), 1)
        ]),
        _createElementVNode("div", {
          class: "lrc",
          ref_key: "lrc",
          ref: lrc
        }, [
          (__props.audioList[focusIndex.value].lrc.length)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "lrc-contents",
                style: _normalizeStyle(`transform:translateY(-${lrcPosition.value}px)`)
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.audioList[focusIndex.value].lrc, (item, index) => {
                  return (_openBlock(), _createElementBlock("p", {
                    key: index,
                    class: _normalizeClass({'lrc-current':pIndex.value === index})
                  }, _toDisplayString(item.text), 3))
                }), 128))
              ], 4))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, "暂无歌词"))
        ], 512),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("div", {
            class: "progress",
            onMousedown: progressMousedown,
            ref_key: "progress",
            ref: progress
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(["progress-item", {'progress-item-transition':isProgressItemTransition.value}]),
              style: _normalizeStyle(`--progressBuffered:${progressBuffered.value}%`)
            }, [
              _createElementVNode("div", {
                class: _normalizeClass(["progress-item-dot", {'progress-item-dot-transition':isProgressItemTransition.value}])
              }, [
                _createElementVNode("span", {
                  style: _normalizeStyle(`--dotBuffered:${progressBuffered.value}`)
                }, null, 4)
              ], 2)
            ], 6)
          ], 544),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("span", null, _toDisplayString(audioCurrentTime.value) + " " + _toDisplayString('/') + " " + _toDisplayString(audioDuration.value), 1),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont", isVolume.value ? 'icon-24gf-volumeDisable' : 'icon-24gf-volumeMiddle']),
                onClick: volumeIconClick
              }, null, 2),
              _createElementVNode("div", {
                class: _normalizeClass(["volume-wrap", {'volume-wrap-height': isVolumeWrapHeightClass.value}])
              }, [
                _createElementVNode("div", {
                  class: "volume-wrap-bar",
                  onMousedown: volumeMousedown,
                  ref_key: "volume",
                  ref: volume
                }, [
                  _createElementVNode("div", {
                    class: "volume-wrap-bar-inner",
                    style: _normalizeStyle(`height: ${volumeBarHeight.value}%;`)
                  }, null, 4)
                ], 544)
              ], 2)
            ]),
            _createElementVNode("div", {
              class: "play-type",
              onClick: playTypeClick
            }, [
              _createElementVNode("i", {
                class: _normalizeClass(["iconfont", playTypeIcon[playType.value]])
              }, null, 2)
            ]),
            _createElementVNode("div", {
              class: "reset",
              onClick: resetClick
            }, _hoisted_12),
            _createElementVNode("div", {
              class: "play-lists",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (isShowPlayerList.value = !isShowPlayerList.value))
            }, _hoisted_14)
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["right-top-icon", {'right-top-icon-rotate': isPlay.value}]),
          style: _normalizeStyle(`--dotBuffered:${progressBuffered.value}`)
        }, _hoisted_16, 6)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["player-list", {'player-list-show': isShowPlayerList.value}])
    }, [
      _createElementVNode("ol", null, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.audioList, (item, index) => {
          return (_openBlock(), _createElementBlock("li", {
            key: index,
            onClick: ($event: any) => (liClick(index)),
            class: _normalizeClass({'li-focus': focusIndex.value === index})
          }, [
            _hoisted_18,
            _createElementVNode("span", _hoisted_19, _toDisplayString(index + 1), 1),
            _createElementVNode("span", _hoisted_20, _toDisplayString(item.title), 1),
            _createElementVNode("span", _hoisted_21, _toDisplayString(item.author), 1)
          ], 10, _hoisted_17))
        }), 128))
      ])
    ], 2)
  ]))
}
}

})